import script from "./MajorPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MajorPage.vue?vue&type=script&lang=ts&setup=true"

import "./MajorPage.vue?vue&type=style&index=0&id=e8d3c28a&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8d3c28a"]])

export default __exports__